import { ICellRendererParams } from "ag-grid-community";
import OverlayMenuButton from '@nkr/components/overlay-menu-button';
import { IUser } from '@nkr/models/index';

const menuItemList = [
    { action: 1, title: 'Edit' },
    { action: 2, title: 'Delete' },
    { action: 3, title: 'Hard Delete' },
    { action: -1, title: '' }
];

interface IProps {
    canHardDelete?: boolean,
    canDelete?: boolean,
    onMenuToggle: (show: boolean) => void,
    onMenuSelection: (eventKey: number, contactId: number) => void,
    currentUser?: IUser
}

export const ActionButtonRenderer = (props: ICellRendererParams & IProps) => {
    const handleMenuToggle = (show: boolean) => {
        props.onMenuToggle(show);
    };

    const handleMenuSelection = (id: number, action: number) => {
        props.onMenuSelection(action, id);
    };

    const getUrl = (action: number, id: number) => {
        switch (action) {
        }

        return null;
    };

    const getMenuItems = () => {
        let menuItems = [];

        menuItems.push(1); 
        menuItems.push(2); 

        if (props.canHardDelete) {
            menuItems.push(3);
        }

        return menuItems;
    };

    const menuItems = getMenuItems().map(item => {
        return menuItemList.find(x => x.action == item);
    });

    const menu = menuItems.map(item => {
        let url = item.action != -1 ? getUrl(item.action, props.data.id) : null;
        let id = item.action >= 0 ? props.data.id : 'div-' + props.data.id + '-' + Math.random() * 10000;

        if (url == null) {
            if (item.action >= 0) {
                return { id, action: item.action, include: true, selectable: true, element: <>{item.title}</> };
            } else {
                return { id, action: item.action, include: true, selectable: false, element: <div style={{ height: 10 }}></div>, divider: true };
            }
        } else {
            return { id, action: item.action, include: true, selectable: false, element: <a href={url}>{item.title}</a>, url, title: item.title };
        }
    });

    return (
        <div style={{ width: '100%', textAlign: 'center' }}>
            <OverlayMenuButton
                menu={menu}
                bsStyle='primary'
                bsSize='xs'
                title='Actions'
                listItemStyle={{ padding: '2px 7.5px', fontSize: 14 }}
                includeCaret={true}
                onToggle={handleMenuToggle}
                onSelect={handleMenuSelection}
            />
        </div>
    );
}
